import { useCallback } from 'react';
import { getMyProfilePhoto } from 'api/services/user-service';
import useApiCall from 'hooks/useApiCall';

export const useGetMyProfilePhoto = () => {
    const { callAPI, loading } = useApiCall<any, Blob>(getMyProfilePhoto);

    const getProfilePhotoMethod = useCallback(async () => {
        const resp = await callAPI(null);
        return resp?.data?.size ? URL.createObjectURL(resp?.data) : undefined;
        }, [callAPI]);

    return { getMyProfilePhotoUrl: getProfilePhotoMethod, getProfilePhotoPending: loading };
};